import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{#if @record.locations.length}}\n  {{join-array (map-by @record.locations \'name\')}}\n{{else}}\n  -\n{{/if}}")